import React from 'react';
import {useQuery} from '@tanstack/react-query';

import {useFeatureFlagsApi} from 'iron/apps/feature-flags/src/api/feature-flags';
import {useFeatureFlagStore} from 'iron/apps/feature-flags/src/store';
import {trackFeatureFlagViewPageAction, ViewPageTrackingEvent} from 'iron/apps/feature-flags/src/tracking';

interface QueryFeatureFlagParams {
  projectId: number;
  flagId: string;
}

export function useQueryFeatureFlag({projectId, flagId}: QueryFeatureFlagParams) {
  const {getFeatureFlag} = useFeatureFlagsApi({projectId});
  const setCurrentFeatureFlag = useFeatureFlagStore((state) => state.setCurrentFeatureFlag);
  const {isSuccess, data: flag} = useQuery({
    queryKey: [`featureFlag`, projectId, flagId],
    queryFn: () => {
      if (flagId) {
        return getFeatureFlag({id: flagId});
      }
      throw new Error(`Feature flag ID is required`);
    },
  });

  React.useEffect(() => {
    if (isSuccess && flag) {
      setCurrentFeatureFlag(flag);
    }
    trackFeatureFlagViewPageAction({
      event: ViewPageTrackingEvent.PageLoaded,
      featureFlag: flag,
      props: {
        isSuccess,
      },
    });
  }, [isSuccess, flag, setCurrentFeatureFlag]);
}
